import styled from 'styled-components';

export const Heading = styled.h1<{ align: 'left' | 'center' | 'right' }>`
  text-align: ${(props) => props.align};
  font-size: 32px;
`;
